import { AccountService } from '../../../services/account.service';
import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { IGroup, IAccount } from '../../../interfaces/graph-types';
import { Observable, Subscription, Subject } from 'rxjs';

type onSelectGroup = (
  verificationAddon: string,
  onsuccess: onSmartSuccess,
  onfailure: onSmartFailure,
) => void;

@Component({
  selector: 'modal-email-verification-selector',
  template: require('./email-verification-selector.component.pug'),
  styles: [require('./email-verification-selector.component.css').toString()],
})
export class ModalEmailVerificationSelectorComponent implements OnInit {
  account: IAccount;

  // Options to pass to the modal:
  accountId: string;
  onSelect: onSelectGroup;
  public reason: Subject<any>;

  sub: Subscription;

  selectedAddon: string;
  success = false;

  // -------------------------------------------------------------------
  constructor(
    public bsModalRef: BsModalRef,
    private accountService: AccountService,
  ) {}

  // -------------------------------------------------------------------
  ngOnInit() {
    this.sub = this.accountService
      .verificationTools(this.accountId)
      .subscribe(res => {
        this.account = res;
      });
    this.reason = new Subject();
  }

  // -------------------------------------------------------------------
  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  // -------------------------------------------------------------------
  close() {
    this.bsModalRef.hide();
    if (this.success) {
      this.reason.next(true);
    }
  }

  // -------------------------------------------------------------------
  save(data: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    this.onSelect(
      this.selectedAddon,
      () => {
        this.success = true;
      },
      onfailure,
    );
  }
}
